import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Index from './index.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/onboarding-invitation'

export default {
  path: basePath,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    permission: 'PREMIUM_ONBOARDING',
    isAllInclude: true,
    isNewPage: true,
    get title () {
      return i18n.t('admin.company.onboarding.title.invitation')
    },
    menu: {
      get label () {
        return i18n.t('admin.company.onboarding.menu.invitation')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        get title () {
          return i18n.t('admin.company.onboarding.title.invitation')
        }
      }
    }
  ]
}
